/* ═══ COPIAR O CUPOM DA BARRA DE AVISOS — [2026-08-22] ══════════════════════
   🔑 ESTE SCRIPT É SÓ DA BARRA. O banner tem o dele, inline, que age nos
     `.cup` de dentro do carrossel — dois scripts globais no mesmo atributo
     copiariam duas vezes e brigariam pela classe de confirmação. Aqui o alvo é
     `.av-cup`, e só.

   🪤 O AVISO TROCA SOZINHO A CADA 4,2s. Se ele mudar entre o toque e a cópia, o
     botão sai da tela com o clique pela metade — por isso o código vem do
     `data-cupom` do próprio elemento, lido no instante do clique, e não de
     nada que dependa de o elemento continuar visível.

   🪤 SEM HTTPS OU EM NAVEGADOR ANTIGO NÃO EXISTE `navigator.clipboard`: sem a
     reserva do `execCommand`, o clique não faria nada e o cupom pareceria
     quebrado. A lição está no script do banner desde 17/08. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var bt = e.target.closest('.av-cup');
    if (!bt) return;
    e.preventDefault();
    e.stopPropagation();
    var codigo = bt.getAttribute('data-cupom');
    if (!codigo) return;

    function pronto() {
      bt.classList.add('feito');
      /* 🪤 A TROCA DO TEXTO É AQUI, NÃO NO CSS. Tentei primeiro com
         `font-size:0` no código e `::after{content:"Copiado"}` — e a pílula não
         recalcula a largura a partir de conteúdo gerado: "Copiado" saía cortado
         na borda. Trocando o textContent de verdade, a caixa encolhe e cresce
         sozinha com o que está dentro dela. */
      var cod = bt.querySelector('.av-cup-cod');
      var textoAntes = cod ? cod.textContent : null;
      if (cod) cod.textContent = 'Copiado';
      /* 🔑 o rótulo muda junto do visual: quem usa leitor de tela não vê a
         mudança de cor, e sem isto não saberia que copiou */
      var antes = bt.getAttribute('aria-label');
      bt.setAttribute('aria-label', 'Cupom ' + codigo + ' copiado');
      setTimeout(function () {
        bt.classList.remove('feito');
        if (cod && textoAntes !== null) cod.textContent = textoAntes;
        if (antes) bt.setAttribute('aria-label', antes);
      }, 1800);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(codigo).then(pronto).catch(pronto);
    } else {
      var c = document.createElement('textarea');
      c.value = codigo;
      c.setAttribute('readonly', '');
      c.style.cssText = 'position:absolute;left:-9999px';
      document.body.appendChild(c);
      c.select();
      try { document.execCommand('copy'); } catch (err) {}
      document.body.removeChild(c);
      pronto();
    }
  });
})();
